export default {
  en: {
    message: 'Adalong is under maintenance, sorry for inconvenience.',
  },
};
